<template>
  <v-container class="giftcardmain">
    <v-row class="justify-center">
      <v-col lg="6" md="8" sm="10" xs="12">
        <router-view />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'GiftCardMain',

  async beforeMount() {
    this.$store.state.checkoutSuccess = false

    if (this.$store.state.session.access_token === undefined) {
      this.$store.commit('setGoToGiftCard', true)

      this.$store.commit('setConfig', null)
      this.$store.state.require_signup = 0
      this.$store.state.require_card = 0

      if (this.$route.query?.giftcard_config_id) {
        this.$store.commit('setDirectToGiftCardId', parseInt(this.$route.query?.giftcard_config_id))
        this.$store.commit('setGiftCardConfigId', this.$route.query?.giftcard_config_id)
      }

      this.$router.push({ name: 'SignupView' })
    } else {
      this.$store.commit('setGoToGiftCard', false)
      this.$store.commit('setConfig', null)
      this.$store.state.require_signup = 0
      this.$store.state.require_card = 0

      if (this.$route.query?.giftcard_config_id !== null && this.$route.query?.giftcard_config_id !== undefined) {
        this.$store.commit('setDirectToGiftCardId', parseInt(this.$route.query?.giftcard_config_id))
        await this.$store.dispatch('getGiftCardConfigs')
        const selectedConfig = this.$store.state.giftCardConfigs.data.find((o) => o.id === this.$store.state.directToGiftCardId)
        this.$store.commit('setGiftCardConfigId', selectedConfig.id)
        this.$store.state.mtek_id = `variants-${selectedConfig.giftCardVariantId}`
        this.$router.push({ name: 'GiftCardGifteeSearch', params: { configId: selectedConfig.id } })
      }
    }
  }
}
</script>

<style lang="scss">

</style>